module.exports = __webpack_public_path__ + "static/media/2.83fc00de.jpg";